import { Card, CardHeader, CardContent } from '@mui/material';
import cx from 'classnames';
import styles from './Card.module.css';

interface MyAccountCardProps {
  avatar?: React.ReactElement;
  title?: React.ReactElement;
  children: React.ReactElement | Array<React.ReactElement>;
  className?: string;
  contentClassName?: string;
}

const MyAccountCard = (props: MyAccountCardProps) => {
  return (
    <Card raised className={cx(styles.root, props.className)}>
      <CardHeader
        className={styles.header}
        avatar={props.avatar || null}
        title={props.title || null}
        disableTypography
      />
      <CardContent className={cx(styles.content, props.contentClassName)}>{props.children}</CardContent>
    </Card>
  );
};

export default MyAccountCard;
